import React, { Component } from "react";
import { Container, Form } from "react-bootstrap";
import './Style.scss'
import dematAccount from '../../../Assets/Images/OPG_account-icon.svg'

export class DematAccount extends Component {
  render() {
    return (
      <>
        <section className="dematAccountContainer">
          <Container className="dematAccount">
            <div className="accountBody">
              <img
                src={dematAccount}
                alt="Demat Account OPG Securities"
                className="accountImg"
                width={100}
              />
              <h1>Open an OPG account</h1>
              <h3>Fast & hassle-free way to open an account!</h3>
              <div className="formContainer">
                <Form>
                  <div className="inputs">
                    <input type="text" name="name" id="number" placeholder="Enter Name" required />
                    <input type="email" name="email" id="number" placeholder="Enter Email" required />
                    <input type="number" name="number" id="number" placeholder="Enter Number" required />
                  </div>
                  <div className="btn">
                    <button type="submit">Sign Up</button>
                  </div>
                </Form>
              </div>
            </div>
          </Container>
        </section>
      </>
    );
  }
}

export default DematAccount;
